import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminConfirmInfo from "../../../components/admin/document/AdminConfirmInfo";

const AdminConfirmInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //보고서 식별자가 없는 경우
    if (!id) {
        return <div>Invalid report ID</div>;
    }

    return (
        <AdminLayout>
            {/*어드민 자동 생성 보고서 정보*/}
            <AdminConfirmInfo reportId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminConfirmInfoPage;